import { TDealsState } from '../../types/deals';

const defaultState: TDealsState = {
  isE2eDealVisible: false,
};

export function dealsReducer(state: TDealsState = defaultState): TDealsState {
  return state;
}
